module.exports = __webpack_public_path__ + "other.svg?dc439eb16a81a18e6061c6212b2cb003";